<script setup lang="ts">
defineProps<{ collapsed?: boolean }>()

const { $trackEvent } = useNuxtApp()
const { completedSteps, steps } = useWorkspaceOnboarding()
const { data: workspace } = useWorkspaceSettings()

const visibleSteps = computed(() => steps.value.filter((step) => !step.hidden))
const totalSteps = computed(() => visibleSteps.value.length)
const completedCount = computed(() => completedSteps.value.length)

const nextIncompleteStep = computed(() =>
  getNextIncompleteOnboardingStep(workspace.value),
)

const progress = computed(() => {
  if (!totalSteps.value) return 0
  return Math.round((completedCount.value / totalSteps.value) * 100)
})

const progressStyle = computed(() => {
  if (progress.value == 0) {
    return { background: "#e5e7eb" }
  }

  return {
    background: `conic-gradient(
    var(--color-violet-400) 0%,
    var(--color-purple-400) ${progress.value / 2}%,
    var(--color-fuchsia-400)${progress.value}%,
    var(--color-zinc-200) ${progress.value}% 100%
  )`,
  }
})

function handleClick() {
  $trackEvent("workspace_onboarding_progress_badge_clicked", {
    progress: `${progress.value}%`,
  })
}
</script>

<template>
  <NuxtLink :to="nextIncompleteStep" @click="handleClick">
    <div
      class="group flex items-center rounded-full bg-white shadow-sm ring-1 ring-zinc-200/70 transition hover:bg-zinc-50"
      :class="
        collapsed ? 'justify-center p-1' : 'justify-between py-2 pr-3 pl-4'
      "
    >
      <div v-if="!collapsed" class="w-min">
        <TypographyText class="text-nowrap text-zinc-900">
          <TypographyStrong>
            {{ $t("workspace_onboarding.progress_badge.workspace_setup") }}
            {{ progress }}%
          </TypographyStrong>
        </TypographyText>
      </div>

      <div class="shrink-0" :class="{ 'ml-1': !collapsed }">
        <div :style="progressStyle" class="relative size-6 rounded-full">
          <div
            class="absolute inset-1 rounded-full bg-white transition group-hover:bg-zinc-50"
          />
        </div>
      </div>
    </div>
  </NuxtLink>
</template>
